import React from "react";
import brampton1 from "../../../assets/image/brampton1.jpg";
import brampton2 from "../../../assets/image/brampton2.jpg";
import brampton3 from "../../../assets/image/brampton3.jpg";
import brampton4 from "../../../assets/image/brampton4.jpg";
import brampton5 from "../../../assets/image/brampton5.jpg";







const branches = [
  {
    name: "Brampton Branch",
    address:
      "2131 Williams Parkway, Unit No. 15, Brampton, Ontario, L6S 5Z4",
    phone: "+1 (438) 927-2958",
    email: "info@trinitymanagementservices.ca",
    hours: "9:30 AM – 5:30 PM",
    map: "https://www.google.com/maps?q=2131+Williams+Parkway,+Unit+No.+9,+Brampton,+Ontario,+L6S+5Z4&output=embed",
    image: brampton1,
  },
  {
    name: "Calgary Branch",
    address:
      "903, 8th Avenue, Unit No. 914, SW Calgary, Alberta, T2P 0P7",
    phone: "+1 (438) 927-2958",
    email: "info@trinitymanagementservices.ca",
    hours: "9:30 AM – 5:30 PM",
    image: brampton2,
    status: "temporarily_closed",
  },
  {
    name: "Montreal Branch",
    address:
      "6830 Avenue Du Parc, Unit No. 382A, Montreal, QC, H3N1W7",
    phone: "+1 (438) 927-2958",
    email: "info@trinitymanagementservices.ca",
    hours: "9:30 AM – 5:30 PM",
    image: brampton3,
  },
  {
    name: "Ottawa Branch",
    address:
      "1390 Prince of Wales Dr., Unit No. 209, Ottawa, Ontario, K2C 3N6",
    phone: "+1 (438) 927-2958",
    email: "info@trinitymanagementservices.ca",
    hours: "9:30 AM – 5:30 PM",
    image: brampton4,
  },

  {
    name: "Surrey Branch",
    address:
      "9850 King George Blvd, Unit - 426, Surrey, British Columbia, V3T 0P9",
    phone: "+1 (438) 927-2958",
    email: "info@trinitymanagementservices.ca",
    hours: "9:30 AM – 5:30 PM",
    image: brampton5,
  },
];

export default function ContactDate() {
  return (
    <div className="max-w-8xl mx-auto px-6 pb-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {branches.map((item, index) => (
          <div key={index} className="group [perspective:1200px]">
            <div
              className="
                relative h-[320px] w-full
                transition-transform duration-700
                [transform-style:preserve-3d]
                group-hover:[transform:rotateY(180deg)]
              "
            >
              {/* FRONT (IMAGE) */}
              <div
                className="
                  absolute inset-0 overflow-hidden rounded-xl
                  [backface-visibility:hidden]
                "
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-full w-full object-cover"
                />
                {item.status === "temporarily_closed" && (
                  <div className="absolute top-3 left-3 bg-red-600 text-white text-xs px-3 py-1 rounded-full font-semibold z-20">
                    Temporarily Closed
                  </div>
                )}
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center p-4">
                  <h5 className="text-xl font-bold text-white">
                    {item.name}
                  </h5>
                </div>
              </div>

              {/* BACK (INFO TEXT) */}
              <div
                className="
                  absolute inset-0 rounded-xl  flex flex-col justify-center p-5 text-white
                  [backface-visibility:hidden]
                  [transform:rotateY(180deg)]
                "
                style={{ backgroundColor: "#162e40" }}
              >
                <h5 className="text-xl font-bold mb-3">
                  {item.name}
                </h5>
                <ul className="text-sm space-y-2 text-gray-200">
                  <li>
                    <strong className="text-white">Address:</strong>{" "}
                    {item.address}
                  </li>
                  <li>
                    <strong className="text-white">Contact:</strong>{" "}
                    {item.phone}
                  </li>
                  <li>
                    <strong className="text-white">Email:</strong>{" "}
                    {item.email}
                  </li>
                  <li>
                    <strong className="text-white">Working Hours:</strong>{" "}
                    {item.hours}
                  </li>
                  {/* <li className="text-white">tservices.ca</li> */}
                </ul>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
